import React from "react";
import InputCheckbox from "../form-parts/InputCheckbox";
import Textarea from "../form-parts/Textarea";
import Errors from "../errors/Errors";
import Dropzone from "../form-parts/Dropzone";
import cuid from "cuid";
import ImageList from "../form-parts/ImageList";
import FormInput from "../form-parts/FormInput";
import { useTranslation } from "react-i18next";
import {getCurrentLanguage} from '../../i18n'
import { withTranslation } from "react-i18next";

const Step1 = (props) => {
  const { t } = useTranslation();
  const onDrop = (acceptedFiles) => {
    // Loop through accepted files
    acceptedFiles.map((file) => {
      // Initialize FileReader browser API
      const reader = new FileReader();
      // onload callback gets called after the reader reads the file data
      reader.onload = function (e) {
        // add the image into the state. Since FileReader reading process is asynchronous, its better to get the latest snapshot state (i.e., prevState) and update it.
        props.handleUploadChange({
          id: cuid(),
          src: e.target.result,
          file: file,
          size: file.size,
          name: file.name,
        });
      };
      // Read the file as Data URL (since we accept only images)
      reader.readAsDataURL(file);
      return file;
    });
  };

  return (
    <div className="container-fluid pl-0">
      <h2>1. {t("complaintForm")}</h2>
      <Errors errorMessages={props.errorMessages} />
      <div className="row">
        <div className="col-lg-6">
          <FormInput
            name="type_of_client"
            required={true}
            onChange={props.handleSelectChange}
            options={props.dictionaries.clientTypes.map((x) => {
              return {
                label: x.label[getCurrentLanguage()],
                value: x.key,
              };
            })}
            invalidFields={props.invalidFields}
            classNamePrefix="custom-select"
            placeholder={t("name")}
          ></FormInput>
        </div>
      </div>
      {props.formData.type_of_client !== undefined && (
        <div>
          {props.formData.type_of_client == "individual_customer" && (
            <div className="row">
              <div className="col-lg-6">
                <FormInput
                  label={t("nameAndSurname")}
                  name="customer_name"
                  required={true}
                  onChange={props.updateFormData}
                  placeholder="..."
                  value={props.formData.customer_name}
                  invalidFields={props.invalidFields}
                />
              </div>
              <div className="col-lg-6">
                <FormInput
                  label={t("customerLanguage")}
                  name="language_name"
                  required={false}
                  onChange={props.updateFormData}
                  value={t("language")}
                  invalidFields={props.invalidFields}
                />
              </div>
            </div>
          )}
          {props.formData.type_of_client == "dealer" && (
            <div className="row">
              <div className="col-lg-6">
                <FormInput
                  label={t("companyName")}
                  name="customer_company_name"
                  required={true}
                  onChange={props.updateFormData}
                  placeholder="..."
                  value={props.formData.customer_company_name}
                  invalidFields={props.invalidFields}
                />
              </div>
            </div>
          )}
          {props.formData.type_of_client == "investor" && (
            <div className="row">
              <div className="col-lg-6">
                <FormInput
                  label={t("investorName")}
                  name="customer_investor_name"
                  required={true}
                  onChange={props.updateFormData}
                  placeholder="..."
                  value={props.formData.customer_investor_name}
                  invalidFields={props.invalidFields}
                />
              </div>
              <div className="col-lg-6">
                <FormInput
                  label={t("vatID")}
                  name="customer_company_nip"
                  required={
                    props.requiredFields.indexOf("number_of_contract") >= 0
                  }
                  onChange={props.updateFormData}
                  placeholder="..."
                  invalidFields={props.invalidFields}
                  value={props.formData.customer_company_nip}
                />
              </div>
            </div>
          )}
          {(props.formData.type_of_client === "dealer" ||
            props.formData.type_of_client === "investor") && (
            <div className="row">
              <div className="col-lg-6">
                <FormInput
                  label={t("complaintPerson")}
                  name="reporting_claims_person"
                  required={true}
                  onChange={props.updateFormData}
                  placeholder="..."
                  value={props.formData.reporting_claims_person}
                  invalidFields={props.invalidFields}
                />
              </div>
              <div className="col-lg-6">
                <FormInput
                  readOnly
                  label={t("customerLanguage")}
                  name="customer_language"
                  required={false}
                  onChange={props.updateFormData}
                  value={t("language")}
                  invalidFields={props.invalidFields}
                />
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-lg-6">
              <FormInput
                label={t("email")}
                name="customer_email"
                required={true}
                onChange={props.updateFormData}
                placeholder="..."
                invalidFields={props.invalidFields}
                value={props.formData.customer_email || ""}
              />
            </div>
            <div className="col-lg-6">
              <FormInput
                label={t("phone")}
                name="complaint_phonenumber"
                required={true}
                onChange={props.updateFormData}
                placeholder="+48 ..."
                invalidFields={props.invalidFields}
                maxLength="12"
                value={props.formData.complaint_phonenumber || ""}
              />
            </div>
          </div>
          {props.formData.type_of_client === "individual_customer" && (
            <div className="row">
              <div className="col-12 reqFieldInfoInvCust">
                <p>
                  <span className="reqStar">*</span> {t("requiredFields")}
                </p>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-lg-6">
              <FormInput
                label={t("orderNumber")}
                name="order_number"
                required={props.requiredFields.indexOf("order_number") >= 0}
                onChange={props.updateFormData}
                placeholder="..."
                invalidFields={props.invalidFields}
                value={props.formData.order_number || ""}
              />
            </div>
            <div className="col-lg-6">
              <FormInput
                label={t("invoiceNumber")}
                name="number_of_invoice"
                required={
                  props.requiredFields.indexOf("number_of_invoice") >= 0
                }
                onChange={props.updateFormData}
                placeholder="..."
                invalidFields={props.invalidFields}
                value={props.formData.number_of_invoice || ""}
              />
            </div>
          </div>
          <div className="row">
            {props.formData.type_of_client === "individual_customer" && (
              <div className="col-lg-6">
                <FormInput
                  label={t("contractNumber")}
                  name="number_of_contract"
                  required={
                    props.requiredFields.indexOf("number_of_contract") >= 0
                  }
                  onChange={props.updateFormData}
                  placeholder="..."
                  value={props.formData.number_of_contract}
                  invalidFields={props.invalidFields}
                />
              </div>
            )}
            <div className="col-lg-6">
              <FormInput
                label={t("position")}
                name="item_from_an_order_or_invoice"
                required={true}
                onChange={props.updateFormData}
                placeholder={t("position2")}
                invalidFields={props.invalidFields}
                maxLength="12"
                value={props.formData.item_from_an_order_or_invoice || ""}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <label>
                  {props.formData.type_of_client === "investor"
                    ? t("investment address")
                    : t("joineryAdress")}
              </label>
              <div className="row">
                <div className="col-12">
                  <FormInput
                    name="area"
                    label={t("area")}
                    required={true}
                    onChange={props.handleSelectChange}
                    options={props.dictionaries.area
                      .sort( (a,b)=> a.order[getCurrentLanguage()]-b.order[getCurrentLanguage()])
                      .map( (x) => {
                      return {
                        label: x.label[getCurrentLanguage()],
                        value: x.key,
                      };
                    })}
                    
                    invalidFields={props.invalidFields}
                    placeholder={t("chooseArea")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <FormInput
                    label={t("postalCode")}
                    name="customer_address_postcode"
                    required={true}
                    onChange={props.updateFormData}
                    placeholder={t("postalCode2")}
                    maxLength="10   "
                    invalidFields={props.invalidFields}
                    value={props.formData.customer_address_postcode || ""}
                  />
                </div>
                <div className="col-6">
                  <FormInput
                    label={t("city")}
                    name="customer_address_city"
                    required={true}
                    onChange={props.updateFormData}
                    placeholder={t("city2")}
                    maxLength="100"
                    invalidFields={props.invalidFields}
                    value={props.formData.customer_address_city || ""}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <FormInput
                    label={t("street")}
                    name="customer_address_street"
                    required={true}
                    onChange={props.updateFormData}
                    placeholder={t("street2")}
                    maxLength="100"
                    invalidFields={props.invalidFields}
                    value={props.formData.customer_address_street || ""}
                  />
                </div>
                <div className="col-lg-6">
                  <FormInput
                    label={t("propertyNumber")}
                    name="customer_address_number"
                    required={true}
                    onChange={props.updateFormData}
                    placeholder={t("propertyNumber2")}
                    invalidFields={props.invalidFields}
                    maxLength="12"
                    value={props.formData.customer_address_number || ""}
                  />
                </div>
              </div>
              {props.formData.type_of_client !== "individual_customer" && (
                <div className="row">
                  <div className="col-lg-6">
                    <FormInput
                      label={t("landlordsPhone")}
                      name="phone_number_owner_of_local"
                      required={true}
                      onChange={props.updateFormData}
                      placeholder={t("dealersPhone")}
                      invalidFields={props.invalidFields}
                      maxLength="12"
                      value={props.formData.phone_number_owner_of_local || ""}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <FormInput
                name="product_name"
                label={t("product")}
                required={true}
                onChange={props.handleSelectChange}
                options={props.dictionaries.productName.map((x) => {
                  return {
                    label: x.label[getCurrentLanguage()],
                    value: x.key,
                  };
                })}
                invalidFields={props.invalidFields}
                placeholder={t("chooseProduct")}
              />
            </div>
            <div className="col-6">
              <FormInput
                label={t("quantity")}
                name="product_amount"
                type="number"
                required={true}
                onChange={props.updateFormData}
                placeholder={t("quantity2")}
                invalidFields={props.invalidFields}
                value={props.formData.product_amount || ""}
              ></FormInput>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <FormInput
                label={t("dateOfPurchase")}
                name="order_date"
                type="date"
                required={true}
                onChange={props.updateFormData}
                placeholder="Podaj datę zakupu"
                invalidFields={props.invalidFields}
                value={props.formData.order_date || ""}
              ></FormInput>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <Textarea
                label={t("productDescription")}
                name="complaint_description"
                required={true}
                onChange={props.updateFormData}
                placeholder="..."
                maxLength="5000"
                invalidFields={props.invalidFields}
                value={props.formData.complaint_description || ""}
              />
            </div>
            <div className="col-lg-6">
              <label>{t("addAttachemnts")}</label>
              <div className="dropzone-wrapper">
                <div className="errors-container">
                  {props.uploadErrors.map((element) => {
                    return element === "type" ? (
                      <div className="single-error">
                        <span>Nieprawidłowy format pliku</span>
                      </div>
                    ) : (
                      <div className="single-error">
                        <span>
                          {t("fileError1")}
                          <em>"{element}"</em> {t("fileError2")}
                        </span>
                      </div>
                    );
                  })}
                </div>
                <ImageList
                  files={props.files}
                  removeItemHandle={props.handleFileRemove}
                  uploadErrors={props.uploadErrors}
                />
                <Dropzone
                  onDrop={onDrop}
                  onDropRejected={props.onDropRejected}
                  accept={
                    "image/*, .doc, .docx, .txt, .pdf, .xlsm, .xlsx, .xlsb, .xltx, .xltm, .xls, .xlt, .xml, .xlam, .xla, .prn, .csv, .wmf, .emf, .bmp, .zip, .rar"
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-lg-6">
          <InputCheckbox
            name="privacyPolicy"
            value={t("declaration")}
            onChange={props.updateFormData}
            invalidFields={props.invalidFields}
            checked={props.formData.privacyPolicy ? true : false}
          />
        </div>
      </div>
    </div>
  );
};

export default withTranslation(["joineryAdress", "investment address"])(Step1);
